import React from 'react';
import {reduxForm, Field } from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withTranslation } from 'react-i18next';

import FieldText from '../../../components/forms/field-text';
import FieldTextarea from '../../../components/forms/field-textarea';
import FieldRadio from '../../../components/forms/field-radio';
import FieldCheckbox from '../../../components/forms/field-checkbox';
import FieldCheckboxOrderAgree from '../../../components/forms/field-checkbox-order-agree';
import FiledRadioInline from  '../../../components/forms/field-radio-inline';

import { createOrder, setWizardStep } from './../../../actions/basket-actions';

import Consts from '../../../core/consts';
import ErrorCode from '../../../core/error-code';
import WizardSteps from '../wizard-steps';

const validate = values => {
    const errors = { };

    if ( !values.phone ) {
        errors.phone = 'Pole je povinné';
    }

    if ( !values.email || !Consts.EMAIL_REGEX.test( values.email.trim() ) ) {
        errors.email = 'E-mail nie je platný';
    }

    if ( !values.firstname ) {
        errors.firstname = 'Pole je povinné';
    }

    if ( !values.lastname ) {
        errors.lastname = 'Pole je povinné';
    }

    if ( !values.street ) {
        errors.street = 'Pole je povinné';
    }

    if ( !values.city ) {
        errors.city = 'Pole je povinné';
    }

    if ( !values.zipCode ) {
        errors.zipCode = 'Pole je povinné';
    }
    
    if ( !values.country ) {
        errors.country = 'Vyberte jednu z možností';
    }

    if ( !values.company ) {
        errors.company = 'Pole je povinné';
    }

    if ( !values.regId ) {
        errors.regId = 'Dodávame iba zákazníkom s IČO';
    }

    if ( values.flagVatId && !values.vatId ) {
        errors.vatId = 'Pole je povinné';
    }

    if ( values.flagDeliveryInfo ) {

        if ( !values.deliveryFirstname ) {
            errors.deliveryFirstname = 'Pole je povinné';
        }

        if ( !values.deliveryLastname ) {
            errors.deliveryLastname = 'Pole je povinné';
        }

        if ( !values.deliveryStreet ) {
            errors.deliveryStreet = 'Pole je povinné';
        }

        if ( !values.deliveryCity ) {
            errors.deliveryCity = 'Pole je povinné';
        }

        if ( !values.deliveryZipCode ) {
            errors.deliveryZipCode = 'Pole je povinné';
        }

    }

    if ( !values.flagCompleteOnly ) {
        errors.flagCompleteOnly = 'Vyberte jednu z možností';
    }

// Dle zakona nesmime vyzadovat nic nad ramec zakona ... Rikal OndraB. Proto to zahazujeme. 
//    if ( !values.flagAgree ) {
//        errors.flagAgree = 'Prosíme o súhlas so spracovaním osobných údajov';
//    }

    return errors;
};

class ContactInfo extends React.Component {

    componentDidMount() {
        dataLayer.push( {
            'event': 'VirtualPageview',
            'virtualPageURL': '/kosik/dodacie-udaje',
            'virtualPageTitle': 'Košík - Dodacie údaje'
        } );
    }

    formSubmit = async ( values ) => {
        const { props: { createOrder } } = this;

        const order = await createOrder( values );
        if ( order ) {
            window.location.href = this.props.settings.links.thankYouBuyLink;
        }
    }

    handleClickPrev = e => {
        const { props: { setWizardStep } } = this;
        e.preventDefault();

        dataLayer.push( {
            'event': 'VirtualPageview',
            'virtualPageURL': document.location.pathname,
            'virtualPageTitle': document.title
        } );

        setWizardStep( WizardSteps.BASKET_OVERVIEW )
    }

    render() {

        const { props: { basketForm, handleSubmit }, formSubmit, handleClickPrev } = this;
        
        //not prepared yet
        if( !basketForm ){
            return null;
        }
        
        return (
                <React.Fragment>
                    <h1>{this.props.t('basket.wizard.contact.orderHeadline')}</h1>     
                    <form onSubmit={handleSubmit( formSubmit )} className="form-horizontal" >
                
                        <div className="row">
                            <div className="col-sm-8 col-sm-offset-2">
                                <h3>{this.props.t('basket.wizard.contact.contactInfo')}</h3>
                            </div>
                        </div>
                
                        <div className="form-group">
                            <div className="col-sm-4  col-sm-offset-2">
                                <Field
                                    name="email"
                                    type="text"
                                    component={FieldText}
                                    label={this.props.t('basket.wizard.contact.email')}
                                    />  
                
                            </div>
                            <div className="col-sm-4">
                                <Field
                                    name="phone"
                                    type="text"
                                    component={FieldText}
                                    label={this.props.t('basket.wizard.contact.phone')}
                                    /> 
                            </div>
                        </div>
                
                        <div className="form-group">
                            <div className="col-sm-4 col-sm-offset-2">
                                <Field
                                    name="firstname"
                                    type="text"
                                    component={FieldText}
                                    label={this.props.t('basket.wizard.contact.firstname')}
                                    />
                
                            </div>
                            <div className="col-sm-4">
                                <Field
                                    name="lastname"
                                    type="text"
                                    component={FieldText}
                                    label={this.props.t('basket.wizard.contact.lastname')}
                                    /> 
                            </div>
                        </div>
                
                        <div className="form-group">
                            <div className="col-sm-4 col-sm-offset-2">
                                <Field
                                    name="street"
                                    type="text"
                                    component={FieldText}
                                    label={this.props.t('basket.wizard.contact.street')}
                                    /> 
                
                            </div>
                            <div className="col-sm-4">
                                <Field
                                    name="city"
                                    type="text"
                                    component={FieldText}
                                    label={this.props.t('basket.wizard.contact.city')}
                                    />  
                            </div>        
                        </div>
                
                        <div className="form-group">
                            <div className="col-sm-4 col-sm-offset-2">
                                <Field
                                    name="zipCode"
                                    type="text"
                                    component={FieldText}
                                    label={this.props.t('basket.wizard.contact.zipCode')}
                                    /> 
                            </div>
                            <div className="col-sm-4">
                                <label>{this.props.t('basket.wizard.contact.country')}</label><div>
                                    <Field name="country" 
                                           component={FiledRadioInline} 
                                           type="radio" 
                                           label="Slovensko"
                                           value="SK"/> 
                                    <Field name="country" 
                                           component={FiledRadioInline} 
                                           type="radio"
                                           label="Česká republika"
                                           value="CZ"/>
                                </div>   
                            </div>
                        </div>
                
                        <div className="row">
                            <div className="col-sm-8 col-sm-offset-2">
                                <h3>{this.props.t('basket.wizard.contact.billingInfo')} <small style={{ color: '#a94442' }}>{this.props.t('basket.wizard.contact.withWatOnly')}</small></h3>
                            </div>
                        </div>
                
                        <div className="form-group">
                            <div className="col-sm-8 col-sm-offset-2">
                                <Field
                                    name="company"
                                    type="text"
                                    component={FieldText}
                                    label={this.props.t('basket.wizard.contact.company')}
                                    />     
                            </div>
                        </div>
                
                        <div className="form-group">
                            <div className="col-sm-4 col-sm-offset-2">
                                <Field
                                    name="regId"
                                    type="text"
                                    component={FieldText}
                                    label={this.props.t('basket.wizard.contact.regId')}
                                    /> 
                            </div>
                            <div className="col-sm-2">
                                <label>&nbsp;</label>
                                <Field
                                    name="flagVatId"
                                    type="checkbox"
                                    component={FieldCheckbox}
                                    label={this.props.t('basket.wizard.contact.flagVatId')}
                                    />                   
                            </div>    
                            <div className="col-sm-2">
                                {basketForm.values && basketForm.values.flagVatId &&
                                    <Field name="vatId"
                                           type="text"
                                           component={FieldText}
                                           label={this.props.t('basket.wizard.contact.vatId')}
                                           />
                                }
                            </div>
                        </div>
                
                
                        <div className="form-group">
                            <div className="col-sm-8 col-sm-offset-2">
                                <Field
                                    name="flagDeliveryInfo"
                                    type="checkbox"
                                    component={FieldCheckbox}
                                    label={this.props.t('basket.wizard.contact.flagDeliveryInfo')}
                                    />   
                            </div>
                        </div> 
                            
                        {basketForm.values && basketForm.values.flagDeliveryInfo && <React.Fragment>               
                            
                            <div className="row">
                                <div className="col-sm-8 col-sm-offset-2">
                                    <h3>{this.props.t('basket.wizard.contact.shippingInfo')}</h3>
                                </div>
                            </div>
                            
                            <div className="form-group">
                                <div className="col-sm-8 col-sm-offset-2">
                                    <Field
                                        name="deliveryCompany"
                                        type="text"
                                        component={FieldText}
                                        label={this.props.t('basket.wizard.contact.company')}
                                        />     
                                </div>
                            </div>
                
                            <div className="form-group">
                                <div className="col-sm-4 col-sm-offset-2">
                                    <Field
                                        name="deliveryFirstname"
                                        type="text"
                                        component={FieldText}
                                        label={this.props.t('basket.wizard.contact.firstname')}
                                        />     
                                </div>
                                <div className="col-sm-4">
                                    <Field
                                        name="deliveryLastname"
                                        type="text"
                                        component={FieldText}
                                        label={this.props.t('basket.wizard.contact.lastname')}
                                        />    
                                </div>
                            </div>
                
                
                            <div className="form-group">
                                <div className="col-sm-4 col-sm-offset-2">
                                    <Field
                                        name="deliveryStreet"
                                        type="text"
                                        component={FieldText}
                                        label={this.props.t('basket.wizard.contact.street')}
                                        />      
                                </div>
                                <div className="col-sm-4">
                                    <Field
                                        name="deliveryCity"
                                        type="text"
                                        component={FieldText}
                                        label={this.props.t('basket.wizard.contact.city')}
                                        />     
                                </div>
                            </div>
                
                            <div className="form-group">
                                <div className="col-sm-4 col-sm-offset-2">
                                    <Field
                                        name="deliveryZipCode"
                                        type="text"
                                        component={FieldText}
                                        label={this.props.t('basket.wizard.contact.zipCode')}
                                        />       
                                </div>                                
                            </div>
                        </React.Fragment>
                        }    
                
                
                        <div className="row">
                            <div className="col-sm-8 col-sm-offset-2">
                                <h3>{this.props.t('basket.wizard.contact.completeOnlyInfo')}</h3>
                            </div>
                        </div>
                
                        <div className="form-group">
                            <div className="col-sm-8 col-sm-offset-2">
                                <Field name="flagCompleteOnly" 
                                       component={FieldRadio} 
                                       type="radio" 
                                       label={this.props.t('basket.wizard.contact.completeOnlyYes')}
                                       value="yes"/> 
                                <Field name="flagCompleteOnly" 
                                       component={FieldRadio} 
                                       type="radio"
                                       label={this.props.t('basket.wizard.contact.completeOnlyNo')}
                                       value="no"/>
                            </div>
                        </div>
                
                        <div className="row">
                            <div className="col-sm-8 col-sm-offset-2">
                                <h3>{this.props.t('basket.wizard.contact.orderNote')}</h3>
                            </div>
                        </div>
                
                        <div className="form-group">
                            <div className="col-sm-8 col-sm-offset-2">
                                <Field  name="flagNote"
                                        type="checkbox"
                                        component={FieldCheckbox}
                                        label={this.props.t('basket.wizard.contact.flagOrderNote')}
                                        />  
                
                            </div>
                        </div>
                
                        {basketForm.values && basketForm.values.flagNote && <React.Fragment>
                
                            <div className="form-group">
                                <div className="col-sm-8 col-sm-offset-2">
                                    <Field
                                        name="note"
                                        type="text"
                                        component={FieldTextarea}
                                        />     
                                </div>
                            </div>                                
                
                        </React.Fragment>
                        }    
                
                        <div className="row">
                            <div className="col-sm-8 col-sm-offset-2">
                                <h3>{this.props.t('basket.wizard.contact.finishOrderInfo')}</h3>
                            </div>
                        </div>
                
                        <div className="form-group">
                            <div className="col-sm-8 col-sm-offset-2">
                
                                <Field  name="flagAgree"
                                        type="checkbox"
                                        component={FieldCheckboxOrderAgree}
                                        />  
                
                                <Field  name="flagNewsletter"
                                        type="checkbox"
                                        component={FieldCheckbox}
                                        label={this.props.t('basket.wizard.contact.flagNewsletter')}
                                        />          
                
                            </div>
                        </div>
                
                        <div className="row basket-bottom">
                            <div className="col-xs-4">
                                <a onClick={handleClickPrev} className="btn btn-lg btn-basket add">{this.props.t('basket.wizard.contact.back')}</a>
                            </div>
                            <div className="col-xs-8 text-right">
                                <button type="submit" className="btn btn-lg btn-basket plus">{this.props.t('basket.wizard.contact.submitOrder')}</button>
                            </div>
                        </div>
                
                    </form>
                </React.Fragment>
                );
    }

}


const mapStateToProps = (state) => ({
    basketForm: state.form.basketForm,
    settings: state.settingsReducer
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createOrder,
    setWizardStep
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({
        form: 'basketForm',
        validate,
        destroyOnUnmount: true, // preserve form data
        forceUnregisterOnUnmount: true // unregister fields on unmount
    })(withTranslation()(ContactInfo))
);
